export const AIScoutFormModel = {
  problem: '',
  requirements: '',
}
